import { Injectable } from '@angular/core';
import { CanActivateChild, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service'; // Ajusta la ruta si es necesario
import { DoctorVerifiedService } from '../api/doctor-verified/doctor-verified.service'; // Ajusta la ruta si es necesario
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DoctorPaymentGuard implements CanActivateChild { // ✅ Cambiado a CanActivateChild

    constructor(
        private authService: AuthService,
        private doctorVerifiedService: DoctorVerifiedService,
        private router: Router,
        private toastr: ToastrService
    ) { }

    // ✅ El método debe llamarse canActivateChild
    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {

        if (!this.authService.isAuthenticated()) {
            // Si no está autenticado, no aplicamos el guard (dejar pasar al login)
            return of(true);
        }


        // 1. Si no es un doctor, no aplicamos esta restricción (dejar pasar)
        if (this.authService.panelType !== 'doctor') {
            return of(true);
        }

        // 2. Si es doctor, verificamos su estado de pago
        return this.doctorVerifiedService.getDoctorVerified().pipe(
            map((response: any) => {
                const data = response.data || response;
                console.log('DoctorPaymentGuard: estado de pago del doctor:', data);

                // Lógica idéntica a Flutter: si no necesita pagar o ya pagó, permitir acceso
                if (data.bill_doctor === false || data.payment_verified === true) {
                    console.log('DoctorPaymentGuard: el doctor no necesita pagar o ya pagó, permitiendo acceso.');
                    return true;
                } else {
                    console.log('DoctorPaymentGuard: el doctor necesita pagar, denegando acceso.');
                }

                // 3. Si no ha pagado, redirigir a la pantalla de planes
                this.toastr.warning('Debes seleccionar y pagar un plan para continuar usando el sistema.');
                return this.router.createUrlTree(['/app/payment-plans']);
            }),
            catchError(() => {
                this.toastr.error('Error al verificar el estado de la cuenta.');
                // En caso de error de red, por seguridad redirigimos a planes para que intente de nuevo
                return of(this.router.createUrlTree(['/app/payment-plans']));
            })
        );
    }
}